import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Zap, ArrowLeft, CheckCircle2 } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError('Si è verificato un errore. Riprova.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        {/* Logo */}
        <Link to="/" className="flex items-center justify-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-xl bg-[#0055FF] flex items-center justify-center">
            <Zap className="w-7 h-7 text-white" strokeWidth={1.5} />
          </div>
          <span className="font-['Outfit'] font-semibold text-2xl tracking-tight">
            Orchestra <span className="text-[#0055FF]">AI</span>
          </span>
        </Link>

        {/* Card */}
        <div className="bg-[#111111] border border-white/10 rounded-3xl p-8">
          {sent ? (
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-[#10B981]/20 flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="w-8 h-8 text-[#10B981]" />
              </div>
              <h1 className="font-['Outfit'] text-2xl font-medium mb-2">Email Inviata!</h1>
              <p className="text-[#A1A1AA] mb-6">
                Se l'email esiste nel sistema, riceverai un link per reimpostare la password.
              </p>
              <Link to="/login">
                <Button className="bg-[#0055FF] hover:bg-[#3377FF] text-white rounded-full px-8">
                  Torna al Login
                </Button>
              </Link>
            </div>
          ) : (
            <>
              <Link to="/login" className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-white mb-6">
                <ArrowLeft className="w-4 h-4" />
                Torna al login
              </Link>
              
              <h1 className="font-['Outfit'] text-2xl font-medium mb-2">Password Dimenticata</h1>
              <p className="text-[#A1A1AA] mb-6">
                Inserisci la tua email e ti invieremo un link per reimpostare la password.
              </p>

              {error && (
                <div className="mb-6 p-4 rounded-xl bg-red-500/10 border border-red-500/30 text-red-400 text-sm" data-testid="forgot-error">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <Label htmlFor="email" className="text-sm font-medium mb-2 block">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="nome@azienda.com"
                    className="input-field"
                    required
                    data-testid="forgot-email-input"
                  />
                </div>

                <Button 
                  type="submit" 
                  disabled={loading}
                  className="w-full bg-[#0055FF] hover:bg-[#3377FF] text-white rounded-full py-6 font-medium"
                  data-testid="forgot-submit-btn"
                >
                  {loading ? 'Invio in corso...' : 'Invia Link Reset'}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
